var _circle, _ellipse, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99999,
    cy: 9.00005,
    r: 7.2,
    fill: "#F1F4F6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.99998,
    cy: 5.84995,
    rx: 0.9,
    ry: 0.9,
    fill: "#6E777C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.09998,
    y: 7.6499,
    width: 1.8,
    height: 5.4,
    rx: 0.9,
    fill: "#6E777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeGray);
export default __webpack_public_path__ + "static/media/noticeGray.36fb5c66b633ad7ffbf332a7ef117b35.svg";
export { ForwardRef as ReactComponent };